import { conflictingButtonChatPages } from '../../context/page-mapping';
import { eventBus } from '../app-utils/event-bus';
import { logNR } from '../app-utils/nr-logging';
import { isHelpCenterHomepage, isBannerPage } from '../app-utils/page-specific-utils';
import { t } from '../app-utils/translations';
import { isHelpPanelAnywherePage, sendEventToHelpAnywherePanel } from '../help-panel-utils/help-panel-events';
import { isChatSessionActive } from '../sf-utils/chat-session';
import { hideDesignHelpButton, isDesignPage } from './design-page-utils';
import { updatePPAGInlineButton } from './ppag-discover-page';

export const hideFloatingButton = () => {
  const customButton = document.getElementById('caHelpButton');
  if (customButton) {
    (customButton as HTMLButtonElement).style.display = 'none';
  }
};

export const showFloatingButton = () => {
  const customButton = document.getElementById('caHelpButton');
  if (customButton) {
    (customButton as HTMLButtonElement).classList.remove('hideCTAbutton');
    (customButton as HTMLButtonElement).style.display = 'flex';
  }
};

export const updateFloatingButtonText = (text: string) => {
  const customButton = document.getElementById('caButtonText');
  if (customButton) (customButton as HTMLElement).innerText = text;
};

export const getCACustomButtonElement = () => {
  const customButton = document.getElementById('caHelpButton');
  if (customButton) return customButton as HTMLButtonElement;
  return undefined;
};

export const isInitialButtonConflicting = () => {
  const pageURL = window.location.href;
  let isConflicting = false;
  // eslint-disable-next-line consistent-return
  conflictingButtonChatPages.forEach((page) => {
    if (pageURL.includes(t(page))) isConflicting = true;
  });
  return isConflicting;
};

export const updateButtonUnreadCount = (text: string, showUnreadCount: boolean) => {
  const unreadCountElement = document.getElementById('caButtonMessageCount');
  if (unreadCountElement) {
    (unreadCountElement as HTMLHtmlElement).innerText = text;
    if (showUnreadCount) {
      unreadCountElement.style.display = 'flex';
    } else {
      unreadCountElement.style.display = 'none';
    }
  }
  // Send event to Help Panel
  if (isHelpPanelAnywherePage()) sendEventToHelpAnywherePanel('unreadMessageCount', text);
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const handleOutsideBH = (channelProviderData: any, enableChat: boolean) => {
  /** Time after which chat will go offline */
  const remainingTime = channelProviderData?.status?.remainingTime;
  const chatStatus = channelProviderData?.status?.isChatEnabled;
  /** Time at which we'll add the code to remove the chat button */
  const minimumTime = 600;
  try {
    /** For pages where chat button is visible, if the chat is online */
    if (enableChat && !isChatSessionActive() && chatStatus) {
      /** If the remaining time is less than 10 mins */
      if (typeof remainingTime === 'number' && remainingTime && remainingTime <= minimumTime) {
        const remainingTimeInMS = remainingTime * 1000;
        if (remainingTimeInMS > 0) {
          console.warn('Chat will be closed after', remainingTime, 'secs');
          logNR('CA_BUSINESS_HR_END', { remainingTime });
          /** add a timeout fn which will remove button after remainingTime is elapsed */
          setTimeout(() => {
            // Check again if session is active or not
            if (!isChatSessionActive()) {
              logNR('CA_HIDE_ON_BUSINESS_HR_END');
              if (isHelpCenterHomepage()) {
                /** SEnd event to HC project */
                eventBus.dispatch('CAchatOffline', {});
              } else if (isDesignPage()) {
                /** Remove button from design page */
                hideDesignHelpButton();
              }
              isBannerPage().then((result) => {
                if (result && result.allowed && result.matchedStyle) {
                  updatePPAGInlineButton(t('start-chat'), true, result.matchedStyle);
                }
              });
              /** Hide CA button */
              hideFloatingButton();
            }
          }, remainingTimeInMS);
        }
      }
    }
  } catch (err) {
    console.error(err);
    logNR('CA_ERROR', {
      errorMessage: 'Error while computing businesss hour end logic',
      errorDetails: (err as Error)?.message,
      errorStack: (err as Error)?.stack,
    });
  }
};
